import { ITransactionDetailsReport } from "../../../interfaces/reports/ITransactionDetailsReport";
import { ToBlob } from "../../../utils/base64Helper";
import { Download } from "../../../utils/file";
import API from "../../apiWrapper";

export const getTransactionDetailsReport = (
    params: ITransactionDetailsReport,
    isPreview: boolean = false
) => {
    return API()
        .post(
            '/Reports/TransactionDetailsReport/GetTransactionDetailsReport',
            params,
            {
                responseType: 'blob',
            }
        )
        .then(
            (res: any) => {
                if (res && res.data) {
                    if (isPreview) {
                        return res.data;
                    } else {
                        const url = window.URL.createObjectURL(new Blob([res.data]));
                        const link = document.createElement('a');
                        let extension = 'xls';
                        var fileName =
                            'TransactionDetailsReport' +
                            '.' +
                            extension;

                        link.href = url;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    }
                }
            },
            (error: any) => {
                return null;
            }
        );
};

